module.exports = __webpack_public_path__ + "86816425dc238061a5d134aaff4e8bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/KR.svg
// module id = pdvs
// module chunks = 0